import React from 'react';
import { SimplifiedAuthProvider } from '@/contexts/SimplifiedAuthContext';

interface SafeAuthProviderProps {
  children: React.ReactNode;
}

/**
 * Simplified Auth Provider - No error boundary needed
 * PreRouteGate handles auth errors and loading states
 * Note: QueryClient is provided at App level to avoid nesting
 */
export const SafeAuthProvider: React.FC<SafeAuthProviderProps> = ({ children }) => {
  // Debug: Track mount/unmount
  React.useEffect(() => {
    console.log('🔵 [SafeAuthProvider] MOUNTED');
    return () => {
      console.log('🔴 [SafeAuthProvider] UNMOUNTED');
    };
  }, []);

  return (
    <SimplifiedAuthProvider>
      {children}
    </SimplifiedAuthProvider>
  );
};